import { connect } from 'react-redux';
import _get from 'lodash-es/get';
import GiftCardPage from './GiftCardPage';
import { closeToast, openErrorToast } from '../../reducers/uiLogic';

const mapStateToProps = state => ({
  toastDetails: _get(state, 'uiLogic.toastDetails', {}),
});

const mapDispatchToProps = dispatch => ({
  showErrorToast: message => dispatch(openErrorToast(message)),
  removeToast: () => dispatch(closeToast()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GiftCardPage);
